<template>
  <v-dialog v-model="dialog" width="650">
    <template v-slot:activator="{ on, attrs }">
      <DeleteBtn v-if="showBtn" :openModal="openModal" v-bind="attrs" v-on="on" />
    </template>
    <transition :duration="150">
      <div class="delete">
        <CloseModalBtn :closeModal="closeModal" />
        <Warning class="warningIcon" />
        <h5 v-if="stage === 1 && textShow" class="text-break">
          {{ textShow }}
        </h5>
        <h5 v-if="stage === 2 && textSecondShow">
          {{ textSecondShow }}
        </h5>
        <v-checkbox
          v-if="textCheckboxShow && stage === 2"
          v-model="checkbox"
          :label="textCheckboxShow"
          class="checkbox"
        ></v-checkbox>
        <div class="group">
          <button v-if="stage === 1" class="delete" @click="deleteItem">
            {{
              textBtn
                ? textBtn
                : !exit
                ? localStorage.translations.pages.common['buttons']['udalit']
                : localStorage.translations.pages.chat.all.group_leave
            }}
          </button>
          <button v-else class="delete" :class="{ disabled: !checkbox }" @click="deleteItemConfirm">
            {{ localStorage.translations.pages.common['buttons']['udalit'] }}
          </button>
          <button class="cancel" @click="closeModal">
            {{ localStorage.translations.pages.common['buttons']['otmenit'] }}
          </button>
        </div>
      </div>
    </transition>
  </v-dialog>
</template>

<script>
import DeleteBtn from 'components/DeleteBtn'

import { createNamespacedHelpers } from 'vuex'
const { mapActions, mapGetters } = createNamespacedHelpers('workType')

import Warning from 'components/icons/Warning'
import CloseModalBtn from 'components/CloseModalBtn'

export default {
  name: 'DeleteModal',
  props: {
    item: Object,
    page: [String, Number],
    limit: [String, Number],
    type: String,
    text: String,
    textSecond: String,
    textCheckbox: String,
    methodDelete: Function,
    methodDeleteConfirm: Function,
    showBtn: {
      type: Boolean,
      default: true,
    },
    deleteId: [String, Number],
    exit: Boolean,
    additionalInfo: [Number, String]
  },
  components: { DeleteBtn, CloseModalBtn, Warning },
  data() {
    return {
      dialog: false,
      checkbox: null,
      stage: 1,
      textShow: this.text ? this.text : null,
      textSecondShow: this.textSecond ? this.textSecond : null,
      textCheckboxShow: this.textCheckbox ? this.textCheckbox : null,
      methodDeleteShow: this.methodDelete ? this.methodDelete : null,
      methodDeleteConfirmShow: this.methodDeleteConfirm ? this.methodDeleteConfirm : null,
      textBtn: null,
    }
  },
  computed: {
    ...mapGetters(['workTypeData']),
    SettingRoles() {
      return this.$route.name === 'SettingRoles'
    },
    SettingWorkTypes() {
      return this.$route.name === 'SettingWorkTypes'
    },
    SettingUsers() {
      return this.$route.name === 'SettingUsers'
    },
    SettingWorkTypesCategory() {
      return this.$route.name === 'SettingWorkTypesCategory'
    },
    SettingProjectType() {
      return this.$route.name === 'SettingProjectType'
    },
    SettingBusinessSegment() {
      return this.$route.name === 'SettingBusinessSegment'
    },
    workClient() {
      return this.$route.name === 'workClient'
    },
    WorkClientSelectedAddress() {
      return this.$route.name === 'clientsCompanyShow' && this.$route.query.tab === 'address'
    },
    WorkClientSelectedContacts() {
      return this.$route.name === 'clientsCompanyShow' && this.$route.query.tab === 'contacts'
    },
    WorkClientSelectedPersons() {
      return this.$route.name === 'clientsCompanyShow' && this.$route.query.tab === 'persons'
    },
    WorkClientSelectedOffices() {
      return this.$route.name === 'clientsCompanyShow' && this.$route.query.tab === 'offices'
    },
    SettingWorkRegion() {
      return this.$route.name === 'SettingWorkRegion'
    },
    SettingEmployeeRoles() {
      return this.$route.name === 'SettingEmployeeRoles'
    },
    SettingWorkDocsSchemeType() {
      return this.$route.name === 'SettingWorkDocsSchemeType'
    },
    SettingWorkDocsDocumentType() {
      return this.$route.name === 'SettingWorkDocsDocumentType'
    },
    SettingWorkDocsSchemeClass() {
      return this.$route.name === 'SettingWorkDocsSchemeClass'
    },
    SettingWorkDocsWorkArea() {
      return this.$route.name === 'SettingWorkDocsWorkAreaProject'
    },
  },
  methods: {
    ...mapActions(['onWorkTypeData', 'onWorkTypeCreate', 'onWorkTypeGrid', 'onWorkTypeUpdate']),
    openModal() {
      this.dialog = true
    },
    closeModal() {
      this.dialog = false
    },
    validate() {
      this.$refs.form.validate()
    },
    async deleteItem() {
      if (this.methodDeleteShow) {
        if (this.deleteId) {
          this.methodDeleteShow(this.deleteId)
        } else this.methodDeleteShow(this.additionalInfo)
      } else if (this.SettingWorkTypes) {
        this.$store
          .dispatch('workType/onWorkTypeDelete', this.item.id)
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
                IsError: false,
              },

              { root: true },
            )
            this.$store.dispatch('workType/onWorkTypeGrid', {
              limit: this.$route.query.limit,
              page: this.$route.query.page,
            })
            this.closeModal()
          })
          .catch((err) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'],
                IsError: true,
              },
              { root: true },
            )
          })
      } else if (this.SettingWorkTypesCategory) {
        this.$store
          .dispatch('workTypeCategory/onWorkTypeCategoryDelete', {
            id: this.item.id,
            checkbox: this.checkbox === true ? 1 : 0,
          })
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
                IsError: false,
              },

              { root: true },
            )
            this.$store.dispatch('workTypeCategory/onWorkTypeCategoryGrid', {
              limit: this.$route.query.limit,
              page: this.$route.query.page,
            })
            this.closeModal()
          })
          .catch((err) => {
            if (err.response.data.message === 'Work type category has related work types.') {
              this.stage = 2
            } else {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message: this.localStorage.translations.pages.common.notifications['oshibka'],
                  IsError: true,
                },
                { root: true },
              )
            }
          })
      } else if (this.SettingRoles) {
        this.$store
          .dispatch('commonRole/onRoleRemove', {
            id: this.item.id,
            checkbox: this.checkbox === true ? 1 : 0,
          })
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
                IsError: false,
              },

              { root: true },
            )
            this.$store.dispatch('commonRole/listOfRoles', {
              limit: this.$route.query.limit,
              page: this.$route.query.page,
            })
            this.closeModal()
          })
          .catch((err) => {
            if (err.response.data.message === 'Role has related users.') {
              this.stage = 2
            } else {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message: this.localStorage.translations.pages.common.notifications['oshibka'],
                  IsError: true,
                },
                { root: true },
              )
            }
          })
      }
      // if (this.SettingUsers) {
      //     this.$store
      //         .dispatch('commonUser/onCommonUserDelete', this.item.id)
      //         .then(response => {
      //             this.$store.dispatch(
      //                 'popup/onMessage',
      //                 {
      //                     message: this.localStorage.translations.pages
      //                         .common.notifications['uspeshno-udaleno'],
      //                     IsError: false
      //                 },

      //                 { root: true }
      //             )
      //             this.$store.dispatch('commonUser/onCommonUserGrid', {
      //                 limit: this.$route.query.limit,
      //                 page: this.$route.query.page
      //             })
      //             this.closeModal()
      //         })
      //         .catch(err => {
      //             this.$store.dispatch(
      //                 'popup/onMessage',
      //                 {
      //                     message: this.localStorage.translations.pages
      //                         .common.notifications['oshibka'],
      //                     IsError: true
      //                 },
      //                 { root: true }
      //             )
      //         })
      // }
      else if (this.SettingProjectType) {
        this.$store
          .dispatch('workProjectType/onWorkProjectTypeDelete', this.item.id)
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
                IsError: false,
              },

              { root: true },
            )
            this.$store.dispatch('workProjectType/onWorkProjectTypeGrid', {
              limit: this.$route.query.limit,
              page: this.$route.query.page,
            })
            this.closeModal()
          })
          .catch((err) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'],
                IsError: true,
              },
              { root: true },
            )
          })
      } else if (this.SettingBusinessSegment) {
        this.$store
          .dispatch('workBusinessSegment/onBusinessSegmentDelete', this.item.id)
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
                IsError: false,
              },

              { root: true },
            )
            this.$store.dispatch('workBusinessSegment/onBusinessSegmentGrid', {
              limit: this.$route.query.limit,
              page: this.$route.query.page,
            })
            this.closeModal()
          })
          .catch((err) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'],
                IsError: true,
              },
              { root: true },
            )
          })
      } else if (this.workClient) {
        this.$store
          .dispatch('workClient/onWorkClientDelete', this.item.id)
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
                IsError: false,
              },

              { root: true },
            )
            this.$store.dispatch('workClient/onWorkClientGrid', {
              limit: this.$route.query.limit,
              page: this.$route.query.page,
            })
            this.closeModal()
          })
          .catch((err) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'],
                IsError: true,
              },
              { root: true },
            )
          })
      } else if (this.WorkClientSelectedAddress) {
        this.$store
          .dispatch('workClientAddress/onWorkClientAddressDelete', this.item.id)
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
                IsError: false,
              },

              { root: true },
            )
            this.$store.dispatch('workClientAddress/onWorkClientAddressGrid', {
              limit: this.$route.query.limit,
              page: this.$route.query.page,
              id: this.item.work_client_id,
            })
            this.closeModal()
          })
          .catch((err) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'],
                IsError: true,
              },
              { root: true },
            )
          })
      } else if (this.WorkClientSelectedPersons) {
        this.$store
          .dispatch('workClientPerson/onWorkClientPersonDelete', this.item.id)
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
                IsError: false,
              },

              { root: true },
            )
            this.$store.dispatch('workClientPerson/onWorkClientPersonGrid', {
              limit: this.$route.query.limit,
              page: this.$route.query.page,
              id: this.item.work_client_id,
            })
            this.closeModal()
          })
          .catch((err) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'],
                IsError: true,
              },
              { root: true },
            )
          })
      } else if (this.WorkClientSelectedContacts) {
        this.$store
          .dispatch('workClientContact/onWorkClientContactDelete', this.item.id)
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
                IsError: false,
              },

              { root: true },
            )
            if (this.item.type === 'email') {
              this.$store.dispatch('workClientContact/onWorkClientContactGridEmail', {
                limit: this.$route.query['email_limit'],
                page: this.$route.query['email_page'],
                id: this.item.work_client_id,
              })
            } else {
              this.$store.dispatch('workClientContact/onWorkClientContactGridPhone', {
                limit: this.$route.query['phone_limit'],
                page: this.$route.query['phone_page'],
                id: this.item.work_client_id,
              })
            }

            this.closeModal()
          })
          .catch((err) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'],
                IsError: true,
              },
              { root: true },
            )
          })
      } else if (this.WorkClientSelectedOffices) {
        this.$store
          .dispatch('workClientOffices/onWorkClientOfficesDelete', this.item.id)
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
                IsError: false,
              },

              { root: true },
            )

            this.$store.dispatch('workClientOffices/onWorkClientOfficesGrid', {
              limit: this.$route.query.limit,
              page: this.$route.query.page,
              id: this.item.work_client_id,
            })

            this.closeModal()
          })
          .catch((err) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'],
                IsError: true,
              },
              { root: true },
            )
          })
      } else if (this.SettingWorkRegion) {
        this.$store
          .dispatch('workRegion/onWorkRegionDelete', this.item.id)
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
                IsError: false,
              },

              { root: true },
            )
            this.$store.dispatch('workRegion/onWorkRegionGrid', {
              limit: this.$route.query.limit,
              page: this.$route.query.page,
            })
            this.closeModal()
          })
          .catch((err) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'],
                IsError: true,
              },
              { root: true },
            )
          })
      } else if (this.SettingEmployeeRoles) {
        this.$store
          .dispatch('employeeRoles/onEmployeeRolesDelete', this.item.id)
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
                IsError: false,
              },

              { root: true },
            )
            this.$store.dispatch('employeeRoles/onEmployeeRolesGrid', {
              limit: this.$route.query.limit,
              page: this.$route.query.page,
            })
            this.closeModal()
          })
          .catch((err) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'],
                IsError: true,
              },
              { root: true },
            )
          })
      } else if (this.type === 'workDocsProjectSchemes') {
        let deleteData = JSON.parse(this.item.files)
        this.$store.dispatch('deleteFile', { url: deleteData[0].url })
        this.$store
          .dispatch('workDocsProjectSchemes/onWorkDocsProjectSchemesDelete', this.item.id)
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
                IsError: false,
              },

              { root: true },
            )
            this.$store.dispatch(
              'workDocsProjectSchemes/onWorkDocsProjectSchemesAll',
              this.$route.params.id,
            )
            this.closeModal()
          })
          .catch((err) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'],
                IsError: true,
              },
              { root: true },
            )
          })
      } else if (this.type === 'workDocsProjectDocuments') {
        let deleteData = JSON.parse(this.item.files)
        this.$store.dispatch('deleteFile', { url: deleteData[0].url })
        this.$store
          .dispatch('workDocsProjectDocuments/onWorkDocsProjectDocumentsDelete', this.item.id)
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
                IsError: false,
              },

              { root: true },
            )
            this.$store.dispatch(
              'workDocsProjectDocuments/onWorkDocsProjectDocumentsAll',
              this.$route.params.id,
            )
            this.closeModal()
          })
          .catch((err) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'],
                IsError: true,
              },
              { root: true },
            )
          })
      } else if (this.SettingWorkDocsSchemeType) {
        this.$store
          .dispatch('workDocsSchemeType/onWorkDocsSchemeTypeDelete', this.item.id)
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
                IsError: false,
              },

              { root: true },
            )
            this.$store.dispatch('workDocsSchemeType/onWorkDocsSchemeTypeGrid', {
              limit: this.$route.query.limit,
              page: this.$route.query.page,
            })
            this.closeModal()
          })
          .catch((err) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'],
                IsError: true,
              },
              { root: true },
            )
          })
      } else if (this.SettingWorkDocsSchemeClass) {
        this.$store
          .dispatch('workDocsSchemeClass/onWorkDocsSchemeClassDelete', this.item.id)
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
                IsError: false,
              },

              { root: true },
            )
            this.$store.dispatch('workDocsSchemeClass/onWorkDocsSchemeClassGrid', {
              limit: this.$route.query.limit,
              page: this.$route.query.page,
            })
            this.closeModal()
          })
          .catch((err) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'],
                IsError: true,
              },
              { root: true },
            )
          })
      } else if (this.SettingWorkDocsDocumentType) {
        this.$store
          .dispatch('workDocsDocumentType/onWorkDocsDocumentTypeDelete', this.item.id)
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
                IsError: false,
              },

              { root: true },
            )
            this.$store.dispatch('workDocsDocumentType/onWorkDocsDocumentTypeGrid', {
              limit: this.$route.query.limit,
              page: this.$route.query.page,
            })
            this.closeModal()
          })
          .catch((err) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'],
                IsError: true,
              },
              { root: true },
            )
          })
      } else if (this.SettingWorkDocsWorkArea) {
        this.$store
          .dispatch('workDocsWorkArea/onWorkDocsWorkAreaDelete', this.item.id)
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
                IsError: false,
              },

              { root: true },
            )
            this.$store.dispatch('workDocsWorkArea/onWorkDocsWorkAreaGrid_project', {
              limit: this.$route.query.limit,
              page: this.$route.query.page,
              project_id: this.$route.params.id,
            })
            this.closeModal()
          })
          .catch((err) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'],
                IsError: true,
              },
              { root: true },
            )
          })
      } else if (this.type === 'workClientProjectsWorkTypePeriod') {
        console.log('test')
        this.$store
          .dispatch('workClientProjectsWorkTypePeriod/onWorkClientProjectsWorkTypePeriodDelete', {
            id: this.item.id,
            checkbox: this.checkbox === true ? 1 : 0,
          })
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
                IsError: false,
              },

              { root: true },
            )
            this.$store.dispatch(
              'workClientProjectsWorkTypePeriod/onWorkClientProjectsWorkTypePeriodAll_project',
              this.$route.params.id,
            )
            this.$store.dispatch('employeeGroup/onEmployeeGroupWorkPeriods', {
              group_id: this.$route.params.id,
              is_extra: this.item.is_extra,
            })
            this.closeModal()
          })
          .catch((err) => {
            if (err.response.data.message === 'Period has related reports.') {
              this.stage = 2
            } else {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message: this.localStorage.translations.pages.common.notifications['oshibka'],
                  IsError: true,
                },
                { root: true },
              )
            }
          })
      } else if (this.type === 'employeeGroup') {
        console.log('test')
        this.$store
          .dispatch('employeeGroup/onEmployeeGroupDelete', this.item.id)
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
                IsError: false,
              },

              { root: true },
            )
            this.$store.dispatch('employeeGroup/onEmployeeGroupGrid', {
              limit: this.$route.query.limit,
              page: this.$route.query.page,
            })
            this.closeModal()
          })
          .catch((err) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'],
                IsError: true,
              },
              { root: true },
            )
          })
      } else if (this.type === 'workExtraType') {
        console.log('test')
        this.$store
          .dispatch('workExtraType/onWorkExtraTypeDelete', this.item.id)
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
                IsError: false,
              },

              { root: true },
            )
            this.$store.dispatch('workExtraType/onWorkExtraTypeGrid', {
              limit: this.$route.query.limit,
              page: this.$route.query.page,
            })
            this.closeModal()
          })
          .catch((err) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'],
                IsError: true,
              },
              { root: true },
            )
          })
      }
    },
    async deleteItemConfirm() {
      if (this.methodDeleteConfirmShow) {
        this.methodDeleteConfirmShow()
      } else if (this.SettingRoles) {
        this.$store
          .dispatch('commonRole/onRoleRemove', {
            id: this.item.id,
            checkbox: this.checkbox === true ? 1 : 0,
          })
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
                IsError: false,
              },

              { root: true },
            )
            this.$store.dispatch('commonRole/listOfRoles', {
              limit: this.$route.query.limit,
              page: this.$route.query.page,
            })
            this.closeModal()
          })
          .catch((err) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'],
                IsError: true,
              },
              { root: true },
            )
          })
      } else if (this.SettingWorkTypesCategory) {
        this.$store
          .dispatch('workTypeCategory/onWorkTypeCategoryDelete', {
            id: this.item.id,
            checkbox: this.checkbox === true ? 1 : 0,
          })
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
                IsError: false,
              },

              { root: true },
            )
            this.$store.dispatch('workTypeCategory/onWorkTypeCategoryGrid', {
              limit: this.$route.query.limit,
              page: this.$route.query.page,
            })
            this.closeModal()
          })
          .catch((err) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'],
                IsError: true,
              },
              { root: true },
            )
          })
      } else if (this.type === 'workClientProjectsWorkTypePeriod') {
        this.$store
          .dispatch('workClientProjectsWorkTypePeriod/onWorkClientProjectsWorkTypePeriodDelete', {
            id: this.item.id,
            checkbox: this.checkbox === true ? 1 : 0,
          })
          .then((response) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
                IsError: false,
              },

              { root: true },
            )
            this.$store.dispatch(
              'workClientProjectsWorkTypePeriod/onWorkClientProjectsWorkTypePeriodAll_project',
              this.$route.params.id,
            )
            this.$store.dispatch('employeeGroup/onEmployeeGroupWorkPeriods', {
              group_id: this.$route.params.id,
              is_extra: this.item.is_extra,
            })
            this.closeModal()
          })
          .catch((err) => {
            if (err.response.data.message === 'Period has related reports.') {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications[
                      'oshibka-nevozmozhno-udalit-bez-podtverzhdeniya'
                    ],
                  IsError: true,
                },
                { root: true },
              )
            } else {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message: this.localStorage.translations.pages.common.notifications['oshibka'],
                  IsError: true,
                },
                { root: true },
              )
            }
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.create {
  background: #277faf;
  box-shadow: 0px 8px 16px rgba(67, 142, 184, 0.2);
  border-radius: 28px;
  padding: 0px 30px !important;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.04em;
  color: #ffffff !important;
  svg {
    margin-right: 16px;
  }
}
.delete {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 30px 30px rgba(39, 127, 175, 0.2);
  text-align: center;
  padding: 45px;
  position: relative;
  display: grid;
  justify-content: center;
  justify-items: center;
  grid-row-gap: 30px;

  .close:deep() {
    padding: 16px;
  }
  .warningIcon:deep() {
    animation: pulsing 2s infinite;
  }

  h5 {
    font-weight: 500;
    font-size: 24px;
    line-height: 1;
    text-align: center;
    word-wrap: break-word;
    white-space: pre-line;
  }
  .checkbox {
    .v-input__slot:deep() {
      .v-icon {
        color: #2c2c2c !important;
        &.primary--text {
          color: #ec1b0e !important;
        }
      }
      label {
        color: #2c2c2c !important;
      }
    }
    &:hover {
      .v-input__slot:deep() {
        .v-icon {
          color: #ec1b0e !important;
          &.primary--text {
            color: #c22015 !important;
          }
        }
        label {
          color: #ec1b0e !important;
        }
      }
    }
  }
  .group {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 24px;
    width: 100%;
    button {
      font-weight: 500;
      font-size: 14px;
      border-radius: 28px;
      letter-spacing: 0.04em;
      text-transform: uppercase;
      padding: 14px;
      transition: 0.3s;
      &.delete {
        background: #ec1b0e;
        color: #ffffff;
        border: 1px solid #ec1b0e;
        &:hover {
          background: #c22015;
          border: 1px solid #c22015;
        }
        &.disabled {
          pointer-events: none;
          filter: grayscale(100%);
        }
      }
      &.cancel {
        border: 1px solid #52525f;
        &:hover {
          background: #277faf;
          color: #ffffff;
          border: 1px solid #277faf;
        }
      }
    }
  }
  @keyframes pulsing {
    0% {
      transform: scale(1, 1);
    }
    50% {
      transform: scale(1.25, 1.25);
    }
    100% {
      transform: scale(1, 1);
    }
  }
}
</style>
